import { PlatformData } from '@/tests/mock-data/mock-content-distribution'

const basicMockPlatformData: PlatformData = {
  sampleRange: '3m',
  engagement: 0,
  engagementRate: 0,
  viewCount: 0,
  viewRate: 0,
  postCount: 0,
  totalPostCount: 0,
  videoCount: 0,
  totalVideoCount: 0,
  followCount: 0,
  platform: '',
  customizedTagName: '',
  customizedTagPostCountRatio: 0,
  subCustomizedTags: [],
}

export const mockPlatforms: PlatformData[] = [
  {
    customizedTagName: 'Travel',
    customizedTagPostCountRatio: 0.67,
    subCustomizedTags: [
      {
        customizedTagName: 'Travel/Taiwan Travel',
        customizedTagPostCountRatio: 0.05,
      },
      {
        customizedTagName: 'Travel/Japan Travel',
        customizedTagPostCountRatio: 0.03,
      },
    ],
    engagementRate: 0.013,
    viewRate: 0.99,
  },
  {
    customizedTagName: 'Beauty and Fashion',
    customizedTagPostCountRatio: 0.49,
    subCustomizedTags: [
      {
        customizedTagName: 'Beauty and Fashion/Beauty Care',
        customizedTagPostCountRatio: 0.11,
      },
      {
        customizedTagName: 'Beauty and Fashion/Makeup',
        customizedTagPostCountRatio: 0.12,
      },
      {
        customizedTagName: 'Beauty and Fashion/Perfume',
        customizedTagPostCountRatio: 0.05,
      },
      {
        customizedTagName: 'Beauty and Fashion/Medical Beauty',
        customizedTagPostCountRatio: 0.05,
      },
    ],
    engagementRate: 0.0003,
    viewRate: 0.45,
  },
  {
    customizedTagName: 'Food',
    customizedTagPostCountRatio: 0.4,
    subCustomizedTags: [
      {
        customizedTagName: 'Food/Dessert',
        customizedTagPostCountRatio: 0.08,
      },
      {
        customizedTagName: 'Food/Beverage',
        customizedTagPostCountRatio: 0.12,
      },
      {
        customizedTagName: 'Food/Noodles',
        customizedTagPostCountRatio: 0.06,
      },
      {
        customizedTagName: 'Food/Recipe',
        customizedTagPostCountRatio: 0.06,
      },
    ],
    engagementRate: 0.0018,
    viewRate: 0.6,
  },
  {
    customizedTagName: 'Technology',
    customizedTagPostCountRatio: 0.2,
    subCustomizedTags: [
      {
        customizedTagName: 'Technology/Consumer Electronics',
        customizedTagPostCountRatio: 0.1,
      },
      {
        customizedTagName: 'Technology/AI and Semiconductor',
        customizedTagPostCountRatio: 0.1,
      },
    ],
    engagementRate: 0.003,
    viewRate: 0.2,
  },
  {
    customizedTagName: 'Fortunetelling',
    customizedTagPostCountRatio: 0.13,
    subCustomizedTags: [],
    engagementRate: 0.033,
    viewRate: 0.21,
  },
].map((platform) => ({
  ...basicMockPlatformData,
  ...platform,
}))
